import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { ResetPasswordFormComponent } from "./reset-password-form.component";

@NgModule({
  declarations: [ResetPasswordFormComponent],
  imports: [CommonModule, CommonTranslateModule, FormsModule, ReactiveFormsModule],
  exports: [ResetPasswordFormComponent],
})
export class ResetPasswordFormModule {}
